import React from 'react'
import Header from '../../components/Header/Header'
import './Products.css'
import Footer from '../../components/Footer/Footer'

const Products = () => {
  return (
    <>
      <Header />
      <div className="slider-container">
        <div className='banner page_head'>
          <div className="container_section_main">
            <div className='col-md-12 text-center'>
              <h2> Products </h2>
            </div>
          </div>

        </div>

      </div>
      <div className="what-all-you-get">
        <div className="container_section_main">
          <div className="row">
            <div className="col-md-12">
              <table className='table table-bordered'>
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3"  style={{ fontWeight: "700" }}>STEROIDS</th>

                  </tr>

                </thead>
              <tbody>
  <tr>
    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>
    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>Products</td>
    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
  </tr>

  <tr><td>1.</td><td>BECLOMETHASONE DIPROPIONATE</td><td>IP/BP/USP</td></tr>
  <tr><td>2.</td><td>BETAMETHASONE</td><td>IP/BP/USP</td></tr>
  <tr><td>3.</td><td>BETAMETHASONE DIPROPIONATE</td><td>IP/BP/USP</td></tr>
  <tr><td>4.</td><td>BETAMETHASONE SODIUM PHOSPHATE</td><td>IP/BP/USP</td></tr>
  <tr><td>5.</td><td>BETAMETHASONE VALERATE</td><td>IP/BP/USP</td></tr>
  <tr><td>6.</td><td>CLOBETASOL PROPIONATE</td><td>IP/BP/USP</td></tr>
  <tr><td>7.</td><td>DEXAMETHASONE</td><td>IP/BP/USP</td></tr>
  <tr><td>8.</td><td>DEXAMETHASONE SODIUM PHOSPHATE</td><td>IP/BP/USP</td></tr>
  <tr><td>9.</td><td>DUTASTERIDE</td><td>IP/USP</td></tr>
  <tr><td>10.</td><td>FLUTICASONE PROPIONATE</td><td>IP/BP/EP</td></tr>
  <tr><td>11.</td><td>HYDROCORTISONE ACETATE</td><td>IP/BP/USP</td></tr>
  <tr><td>12.</td><td>METHYLPREDNISOLONE</td><td>IP/BP/USP</td></tr>
  <tr><td>13.</td><td>METHYLPREDNISOLONE ACETATE</td><td>IP/BP/USP</td></tr>
  <tr><td>14.</td><td>MOMETASONE FUROATE</td><td>IP/BP/USP</td></tr>
  <tr><td>15.</td><td>PREDNISOLONE</td><td>IP/BP/USP</td></tr>
  <tr><td>16.</td><td>PREDNISOLONE ACETATE</td><td>IP/BP/USP</td></tr>
  <tr><td>17.</td><td>PREDNISOLONE SODIUM PHOSPHATE</td><td>IP/BP/USP</td></tr>
  <tr><td>18.</td><td>URSODEOXYCHOLIC ACID</td><td>IP/BP/USP</td></tr>
</tbody>



              </table>
            </div>
             <div className="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>HORMONES</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">19.</td>
                    <td width="55%" align="left" valign="middle">NANDROLONE DECANOATE</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">20.</td>
                    <td width="55%" align="left" valign="middle">TESTOSTERONE </td>
                    <td width="35%" align="left" valign="middle">USP</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">21.</td>
                    <td width="55%" align="left" valign="middle">TESTOSTERONE CYPIONATE</td>
                    <td width="35%" align="left" valign="middle">USP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">22.</td>
                    <td width="55%" align="left" valign="middle">TESTOSTERONE DECANOATE</td>
                    <td width="35%" align="left" valign="middle">BP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">23.</td>
                    <td width="55%" align="left" valign="middle">TESTOSTERONE ISO CAPROATE</td>
                    <td width="35%" align="left" valign="middle">BP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">24.</td>
                    <td width="55%" align="left" valign="middle">TESTOSTERONE PROPIONATE</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">25.</td>
                    <td width="55%" align="left" valign="middle">TESTOSTERONE UNDECANOATE</td>
                    <td width="35%" align="left" valign="middle">IHS</td>
                  </tr>

                  

                </tbody>
              </table>

            </div>
              {/* <div class="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>AntidiabeticS Drugs</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">21.</td>
                    <td width="55%" align="left" valign="middle">METHYLCOBALAMIN</td>
                    <td width="35%" align="left" valign="middle">JP/IP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">22.</td>
                    <td width="55%" align="left" valign="middle">CHOLECALCIFEROL (VITAMIN D3)</td>
                    <td width="35%" align="left" valign="middle">IP/USP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">23.</td>
                    <td width="55%" align="left" valign="middle">D-BIOTIN</td>
                    <td width="35%" align="left" valign="middle">BP/USP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">24.</td>
                    <td width="55%" align="left" valign="middle">BENFOTIAMINE</td>
                    <td width="35%" align="left" valign="middle">IH</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">25.</td>
                    <td width="55%" align="left" valign="middle">ASCORBIC ACID</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">26.</td>
                    <td width="55%" align="left" valign="middle">THIAMIN HYDROCHLORIDE</td>
                    <td width="35%" align="left" valign="middle">IP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">27.</td>
                    <td width="55%" align="left" valign="middle">LYCOPIN</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>



                </tbody>
              </table>

            </div> */}
                 <div className="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>ANTIDIABETICS</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">26.</td>

                    <td width="55%" align="left" valign="middle">  DAPAGLIFLOZIN PROPANEDIOL	</td>
                    <td width="35%" align="left" valign="middle">USP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">27.</td>

                    <td width="55%" align="left" valign="middle">LINAGLIPTIN	</td>
                    <td width="35%" align="left" valign="middle">IH</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">28.</td>

                    <td width="55%" align="left" valign="middle">VILDAGLIPTIN	</td>
                    <td width="35%" align="left" valign="middle">IP</td>
                  </tr>


                </tbody>
              </table>
            </div>
                 <div className="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>Proton Pump Inhibitors</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                   <tr>
                    <td align="left" valign="middle">29.</td>

                    <td width="55%" align="left" valign="middle">  PANTOPRAZOLE SODIUM	</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">30.</td>

                    <td width="55%" align="left" valign="middle">  RABEPRAZOLE	SODIUM</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>
                 
                


                </tbody>
              </table>
            </div>
                 <div className="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>Antibiotics</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                   <tr>
                    <td align="left" valign="middle">31.</td>

                    <td width="55%" align="left" valign="middle">  AZITHROMYCIN	</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">32.</td>

                    <td width="55%" align="left" valign="middle">  ERYTHROMYCIN STEARATE</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">33.</td>

                    <td width="55%" align="left" valign="middle">  OFLOXACIN</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>
                 
                


                </tbody>
              </table>
            </div>
                 <div className="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>Anti Inflammatory</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                   <tr>
                    <td align="left" valign="middle">34.</td>

                    <td width="55%" align="left" valign="middle"> ETORICOXIB 	</td>
                    <td width="35%" align="left" valign="middle">IP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">35.</td>

                    <td width="55%" align="left" valign="middle">IBUPROFEN 	</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">36.</td>

                    <td width="55%" align="left" valign="middle">THIOCOLCHICOSIDE	</td>
                    <td width="35%" align="left" valign="middle">IP/BP/EP</td>
                  </tr>
                 
                


                </tbody>
              </table>
            </div>
            <div class="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>Vitamins</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                   <tr>
                    <td align="left" valign="middle">37.</td>
                    <td width="55%" align="left" valign="middle">ASCORBIC ACID</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>
                   <tr>
                    <td align="left" valign="middle">38.</td>
                    <td width="55%" align="left" valign="middle">BENFOTIAMINE</td>
                    <td width="35%" align="left" valign="middle">IH</td>
                  </tr>
 <tr>
                    <td align="left" valign="middle">39.</td>
                    <td width="55%" align="left" valign="middle">BIOTIN</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>
                     <tr>
                    <td align="left" valign="middle">40.</td>
                    <td width="55%" align="left" valign="middle">CHOLECALCIFEROL </td>
                    <td width="35%" align="left" valign="middle">IP/USP</td>
                  </tr>
                    <tr>
                    <td align="left" valign="middle">41.</td>
                    <td width="55%" align="left" valign="middle">THIAMIN HYDROCHLORIDE</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>
                    <tr>
                    <td align="left" valign="middle">42.</td>
                    <td width="55%" align="left" valign="middle">METHYL COBALAMIN/MECOBALAMIN</td>
                    <td width="35%" align="left" valign="middle">IP/USP/JP</td>
                  </tr>


               


                </tbody>
              </table>

            </div>
           
       

            {/* <div className="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>NSAID</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                 


                </tbody>
              </table>
            </div> */}
            {/* <div className="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>ANTIDIABETIC</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">41.</td>

                    <td width="55%" align="left" valign="middle">  LINAGLIPTIN	</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>

                  <tr>
                    <td align="left" valign="middle">42.</td>

                    <td width="55%" align="left" valign="middle">DAPAGLIFLOZIN	</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">43.</td>

                    <td width="55%" align="left" valign="middle">VIDAGLIPTIN	</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>


                </tbody>
              </table>
            </div> */}
            {/* <div className="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>ANTI HYPERTENSIVE</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">44.</td>

                    <td width="55%" align="left" valign="middle">  TELMISARTAN	</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>




                </tbody>
              </table>
            </div> */}
            {/* <div className="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>PPI INHIBITOR</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                 




                </tbody>
              </table>
            </div> */}
            {/* <div className="col-md-12 mt-3">
              <table class="table table-bordered">
                <thead class="thead-dark">
                  <tr>
                    <th colspan="3" style={{ fontWeight: "700" }}>BILIARY AGENTS</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="10%" style={{ textAlign: "left", fontWeight: "700" }}>S. No.</td>

                    <td width="55%" style={{ textAlign: "left", fontWeight: "700" }}>  Products	</td>
                    <td width="35%" style={{ textAlign: "left", fontWeight: "700" }}>Pharmacopoeia</td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">47.</td>

                    <td width="55%" align="left" valign="middle">  URSODEOXYCHOLIC ACID (UDC)	</td>
                    <td width="35%" align="left" valign="middle">IP/BP/USP</td>
                  </tr>



                </tbody>
              </table>
            </div> */}




          </div>
          <p class=" mt4"><strong>Disclaimer:</strong> API / Substances covered by patent are not offered to the countries where the patent law is in force. However, the final responsibility lies with the customer.</p>
        </div>
      </div>
      <Footer />


    </>
  )
}

export default Products